import React, { useState, useEffect } from "react";
import ScrapingForm from "./ScrapingForm";
import FilteringForm from "./FilteringForm";

// Все подтипы теперь показывают фильтрующие блоки в combined режиме
const SIMPLE_PROCESSING_SUBTYPES = [];

export default function ScrapingFilteringForm({ IS_ADMIN, onSave, onCancel, taskName, prefillData = null }) {
  const [scrapingState, setScrapingState] = useState(null);
  const [preAdbFilterState, setPreAdbFilterState] = useState(null);
  const [preScreenshotFilterState, setPreScreenshotFilterState] = useState(null);

  // Instagram Pages + "Process via ADB" toggle → the 4-stage chain
  const isAdbChain =
    !!IS_ADMIN &&
    scrapingState?.selectedPlatform === "instagram_pages" &&
    scrapingState?.adbAfterScraping === true;

  // Facebook + "Facebook Page Screenshot" toggle → the 4-stage chain
  const isFacebookScreenshotChain =
    !!IS_ADMIN &&
    (scrapingState?.selectedPlatform === "facebook_posts" || 
     scrapingState?.selectedPlatform === "facebook_pages") &&
    scrapingState?.screenshotAfterScraping === true;

  // Instagram ADB Processing subtype selected
  const isAdbProcessingSubtype = scrapingState?.selectedPlatform === "instagram_adb";
  
  // Facebook Screenshot subtype selected
  const isScreenshotSubtype = scrapingState?.selectedPlatform === "facebook_screenshot";

  // Clean up stale filter states when toggling chains off
  useEffect(() => {
    if (!isAdbChain) setPreAdbFilterState(null);
  }, [isAdbChain]);

  useEffect(() => {
    if (!isFacebookScreenshotChain) setPreScreenshotFilterState(null);
  }, [isFacebookScreenshotChain]);

  return (
    <>
      <ScrapingForm
        IS_ADMIN={IS_ADMIN}
        mode="combined"
        onStateChange={setScrapingState}
        taskName={taskName}
        // Передаем onSave и onCancel только для простых режимов (которые не используются)
        onSave={onSave}
        onCancel={onCancel}
        prefillData={prefillData?.scraping}
      />

      {isAdbChain ? (
        <>
          {/* Stage 1: filter applied right after scraping, before ADB processing */}
          <FilteringForm
            key="pre-adb-filter"
            IS_ADMIN={IS_ADMIN}
            mode="combined"
            submitRole="intermediate"
            storageKeySuffix="preAdb"
            scrapingState={scrapingState}
            onStateChange={setPreAdbFilterState}
            taskName={taskName}
            prefillData={prefillData?.filtering}
            stageLabel="Filter — Step 1 (right after scraping, before ADB)"
            effectiveSubtypeOverride={scrapingState?.selectedPlatform}
          />

          {/* Stage 2: filter applied after ADB processing finishes */}
          <FilteringForm
            key="post-adb-filter"
            IS_ADMIN={IS_ADMIN}
            mode="combined"
            submitRole="final"
            storageKeySuffix="postAdb"
            isAdbChainStage2
            scrapingState={scrapingState}
            preAdbFilterState={preAdbFilterState}
            taskName={taskName}
            onSave={onSave}
            onCancel={onCancel}
            prefillData={prefillData?.postAdbFiltering}
            stageLabel="Filter — Step 2 (after ADB processing)"
            effectiveSubtypeOverride="instagram_adb"
          />
        </>
      ) : isFacebookScreenshotChain ? (
        <>
          {/* Stage 1: filter applied right after scraping, before screenshot processing */}
          <FilteringForm
            key="pre-screenshot-filter"
            IS_ADMIN={IS_ADMIN}
            mode="combined"
            submitRole="intermediate"
            storageKeySuffix="preScreenshot"
            scrapingState={scrapingState}
            onStateChange={setPreScreenshotFilterState}
            taskName={taskName}
            prefillData={prefillData?.filtering}
            stageLabel="Filter — Step 1 (right after scraping, before Screenshot)"
            effectiveSubtypeOverride={scrapingState?.selectedPlatform}
          />

          {/* Stage 2: filter applied after screenshot processing finishes */}
          <FilteringForm
            key="post-screenshot-filter"
            IS_ADMIN={IS_ADMIN}
            mode="combined"
            submitRole="final"
            storageKeySuffix="postScreenshot"
            isScreenshotChainStage2
            scrapingState={scrapingState}
            preScreenshotFilterState={preScreenshotFilterState}
            taskName={taskName}
            onSave={onSave}
            onCancel={onCancel}
            prefillData={prefillData?.postScreenshotFiltering}
            stageLabel="Filter — Step 2 (after Screenshot processing)"
            effectiveSubtypeOverride="facebook_screenshot"
          />
        </>
      ) : (
        /* Все остальные случаи (включая ADB Processing и Screenshot подтипы) */
        <FilteringForm
          IS_ADMIN={IS_ADMIN}
          mode="combined"
          scrapingState={scrapingState}
          taskName={taskName}
          onSave={onSave}
          onCancel={onCancel}
          prefillData={prefillData?.filtering}
          effectiveSubtypeOverride={
            isAdbProcessingSubtype ? "instagram_adb" : 
            isScreenshotSubtype ? "facebook_screenshot" : 
            null
          }
        />
      )}
    </>
  );
}